import {APIService} from "../../common/APIService";
import {Supplier} from "../../dto/Supplier";

export class SupplierService extends APIService {
  public async browse() {
    const json = await this.getJson<{data: object[]}>(`suppliers`)
    return json.data.map(item => Supplier.fromJson(item))
  }

  public async add(name: string, streetname?: string, houseNumber?: string, houseNumberAddition?: string, city?: string, postalCode?: string, email?: string, phone?: string, vatRate?: string) {
    const json = await this.postJson<{data: object[]}>(`suppliers`, {
      name: name,
      ...((streetname != undefined && streetname != "") ? {street_name: streetname} : {}),
      ...((houseNumber != undefined && houseNumber != "") ? {house_number: houseNumber} : {}),
      ...((houseNumberAddition != undefined && houseNumberAddition != "") ? {house_number_addition: houseNumberAddition} : {}),
      ...((city != undefined && city != "") ? {city: city} : {}),
      ...((postalCode != undefined && postalCode != "") ? {postal_code: postalCode} : {}),
      ...((email != undefined && email != "") ? {email: email} : {}),
      ...((phone != undefined && phone != "") ? {phone: phone} : {}),
      ...((vatRate != undefined && vatRate != "") ? {vat_rate: vatRate} : {}),
    })
    return Supplier.fromJson(json.data)
  }

  public async edit(supplierId: string, name: string, streetname?: string, houseNumber?: string, houseNumberAddition?: string, city?: string, postalCode?: string, email?: string, phone?: string, vatRate?: string) {
    const json = await this.putJson<{data: object[]}>(`suppliers/${supplierId}`, {
      name: name,
      ...((streetname != undefined && streetname != "") ? {street_name: streetname} : {}),
      ...((houseNumber != undefined && houseNumber != "") ? {house_number: houseNumber} : {}),
      ...((houseNumberAddition != undefined && houseNumberAddition != "") ? {house_number_addition: houseNumberAddition} : {}),
      ...((city != undefined && city != "") ? {city: city} : {}),
      ...((postalCode != undefined && postalCode != "") ? {postal_code: postalCode} : {}),
      ...((email != undefined && email != "") ? {email: email} : {}),
      ...((phone != undefined && phone != "") ? {phone: phone} : {}),
      ...((vatRate != undefined && vatRate != "") ? {vat_rate: vatRate} : {}),
    })
    return Supplier.fromJson(json.data)
  }

  public async delete(supplierId: string): Promise<void> {
    await this.deleteJson<{data: object[]}>(`suppliers/${supplierId}`)
  }
}